import ConceptsList from 'approot/shared/concepts/concepts-list';
import { LessonBigIdeasFragment } from './__generated__/LessonBigIdeasFragment';

const BigIdeasView = ({ content }: { content: LessonBigIdeasFragment }) =>
  content.bigIdeas ? <ConceptsList concepts={content.bigIdeas} /> : null;

export default BigIdeasView;
